import request from "../utils/request";

export async function GetCustomerByQr(payload){
  return request.get("Campaign/GetCustomerByQr?qr=" + payload);
}

export async function ResetCampaign(payload){
  return request.get("Campaign/ResetCampaign?campaignId=" + payload);
}

export async function ResetTotalUsage(payload){
  return request.get("Campaign/ResetTotalUsage?campaignId=" + payload);
}

export async function GetCampaignUsageReport(campaignId) {
  return request.get("Campaign/GetCampaignUsageReport?campaignId=" + campaignId);
}

export async function GetAllCampaigns(payload) {
  return request.get("Campaign/List", {
    params: {
      campaignId: payload.campaignId,
      title: payload.title,
      description: payload.description,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      isPublished : payload.isPublished,
      isMoodFelek : payload.isMoodFelek
    }
  });
}

export async function UpdateCampaign(payload) {
 
  let body = {
    campaignType: payload.campaignType,
    days: payload.days,
    description: payload.description,
    descriptionEn: payload.descriptionEn,
    endDate: payload.endDate,
    endHour: payload.endHour,
    giftExpireTime: parseInt(payload.giftExpireTime),
    image: payload.image,
    startDate: payload.startDate,
    startHour: payload.startHour,
    title: payload.title,
    titleEn: payload.titleEn,
    isRecursive: payload.isRecursive,
    allowRestItemsInGift: payload.allowRestItemsInGift,
    totalUsageLimit: parseInt(payload.totalUsageLimit),
    usedBy: 0,
    usagePersonTimes: parseInt(payload.usagePersonTimes),
    isPublished: false,
    isMoodFelek: false,
    id: payload.id,
    moodProfileImageUrl : payload.moodProfileImageUrl
  };
  return request.post("Campaign/UpdateCampaign", body);
}

export async function UpdateCampaignGift(payload) {
  let body = {
    id: payload.id,
    campaignId : payload.campaignId,
    entityIds: payload.entityIds,
    entityType: payload.entityType,
    amountType: payload.amountType,
    amount: parseFloat(payload.amount)
  }
  return request.post("Campaign/UpdateCampaignGift", body);
}

export async function SetCampaignPublish(payload) {
  return request.post("Campaign/SetCampaignPublish?campaignId=" + payload);
}

export async function SetCampaignMoodfelek(payload) {
  return request.post("Campaign/SetCampaignMoodfelek?campaignId=" + payload);
}

export async function UpdateRestriction(payload) {
  let body = {
    id: payload.id,
    campaignId: payload.campaignId,
    entityIds: payload.entityIds,
    entityType: payload.entityType,
    amountType: payload.amountType,
    amount: parseFloat(payload.amount)
  }
  return request.post("Campaign/UpdateRestriction", body);
}

export async function SetCampaignBranches(payload) {
  return request.post("Campaign/SetCampaignBranches", payload);
}

export async function NewCampaign(payload) {
  let body = {
    campaignType: payload.campaignType,
    days: payload.days,
    description: payload.description,
    descriptionEn: payload.descriptionEn,
    endDate: payload.endDate,
    endHour: payload.endHour,
    giftExpireTime: parseInt(payload.giftExpireTime),
    image: payload.image,
    startDate: payload.startDate,
    startHour: payload.startHour,
    title: payload.title,
    titleEn: payload.titleEn,
    isRecursive: payload.isRecursive,
    allowRestItemsInGift: payload.allowRestItemsInGift,
    totalUsageLimit: parseInt(payload.totalUsageLimit),
    usedBy: 0,
    usagePersonTimes: parseInt(payload.usagePersonTimes),
    isPublished: false,
    isMoodFelek: false,
    moodProfileImageUrl : payload.moodProfileImageUrl
  };
  return request.post("Campaign/NewCampaign", body);
}

export async function DeleteCampaign(payload) {
  return request.delete("Campaign/Campaign?id=" + payload);
}

export async function AddRestriction(payload) {
  let body = {
    campaignId : payload.campaignId,
    entityIds : payload.entityIds,
    entityType: payload.entityType,
    amountType : payload.amountType,
    amount : parseFloat(payload.amount)
  }
  return request.post("Campaign/AddRestriction", body);
}

export async function DeleteCampaignRestriction(payload) {
  return request.delete("Campaign/CampaignRestriction?id=" + payload);
}

export async function DeleteCampaignGift(payload) {
  return request.delete("Campaign/CampaignGift?id=" + payload);
}

export async function AddCampaignGift(payload) {
  let body = {
    campaignId : payload.campaignId,
    entityIds: payload.entityIds,
    entityType: payload.entityType,
    amountType: payload.amountType,
    amount: parseFloat(payload.amount)
  }
  return request.post("Campaign/AddCampaignGift",body);
}

export async function FindAvailableCampaigns(payload) {
  return request.post("Campaign/FindAvailableCampaigns", payload);
}

export async function SimulateCampaign(payload) {
  let body = {
    isRecursive: payload.isRecursive,
    allowRestItemsInGift: payload.allowRestItemsInGift,
    campaignGifts: (payload.campaignGifts || []).map(g => ({
      entityType: g.entityType,
      amountType: g.amountType,
      amount: parseFloat(g.amount),
      entityIds: g.entityIds
    })),
    campaignRests: (payload.campaignRests || []).map(r => ({
      entityType: r.entityType,
      amountType: r.amountType,
      amount: parseFloat(r.amount),
      entityIds: r.entityIds
    }))
  };
  return request.post("Campaign/SimulateCampaign", body);
}

export async function GetCampaignDetails(payload) {
  return request.get("Campaign/GetCampaignDetail?campaignId=" + payload);
}

export async function GetGiftOptions(payload) {
  return request.get("Campaign/GetGiftOptions?entityType=" + payload);
}

export async function MoveIn(payload, direction, entityType) {
  return request.get("Campaign/MoveIn?id=" + payload + "&direction=" + direction + "&entityType=" + entityType);
}

export async function GetNameList(){
  return request.get("Campaign/NameList");
}
